import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../Redux';
import AppHeader from '../../Components/AppHeader';
import AppFooter from '../../Components/AppFooter';
import CompleteRegistrationDialog from '../../Components/CompleteRegistrationDialog';
import Sidebar from '../../Components/Sidebar';
import SagaMessage from '../../Components/SagaMessage';
import AuthenticatedGlobalManagers from '../../Components/AuthenticatedGlobalManagers';
import ReconnectionStatusUI from '../../Components/ReconnectionStatus';
import { classNames } from '../../Utils/classnames';
import { searchParamsSchema } from '../../Utils/routeSchema';
import LoginPage from '../../Containers/LoginPage';

const genericSagaToast: number = 10007;

export const Route = createFileRoute('/(main)/_layout')({
  component: RouteComponent,
  // TODO: use zod to actually validate schema
  validateSearch: searchParamsSchema,
});

function RouteComponent() {
  const searchParams = Route.useSearch();
  const { authenticated: isAuthenticated } = useSelector((state: RootState) => state.auth);
  const sidebarRef = useRef<HTMLDivElement | null>(null);

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  const sidebar = searchParams['sidebar'] || '';
  const hasSidebar = Boolean(searchParams['sidebar']);

  return (
    <div
      className={classNames(
        'page',
        { 'has-sidebar': hasSidebar },
        { [`sidebar-${sidebar}`]: hasSidebar },
        { 'sidebar-expanded': searchParams['sidebar-expanded'] },
      )}
    >
      <AuthenticatedGlobalManagers />
      <AppHeader />
      <div className="content-area" id="layout">
        <SagaMessage toastId={genericSagaToast} />
        <main className="main-content" aria-label="Main content area">
          <Outlet />
        </main>
        <aside id="sidebar" ref={sidebarRef}>
          <Sidebar sidebarRef={sidebarRef} />
        </aside>
      </div>
      <ReconnectionStatusUI />
      <AppFooter />
      <CompleteRegistrationDialog />
    </div>
  );
}
